import React, { useEffect, useState } from 'react';
import { Snackbar, Button } from '@mui/material';

export default function UpdatePrompt() {
  const [waitingWorker, setWaitingWorker] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = (event) => {
      setWaitingWorker(event.detail);
      setOpen(true);
    };
    window.addEventListener('sw-update-available', handler);
    return () => window.removeEventListener('sw-update-available', handler);
  }, []);

  const handleUpdate = () => {
    if (waitingWorker) {
      let reloaded = false;
  
      const reload = () => {
        if (!reloaded) {
          reloaded = true;
          window.location.reload();
        }
      };
  
      // Wait for the new SW to fully activate before reloading
      const onStateChange = () => {
        if (waitingWorker.state === 'activated') {
          waitingWorker.removeEventListener('statechange', onStateChange);
          reload();
        }
      };
  
      waitingWorker.addEventListener('statechange', onStateChange);
  
      // Fallback in case statechange never reaches 'activated'
      setTimeout(reload, 5000);
  
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
    }
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      message="A new version is available"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      action={
        <Button color="secondary" size="small" onClick={handleUpdate}>
          Update Now
        </Button>
      }
    />
  );
}